import React, { useState, useEffect } from "react";
import Paragraph from "@arctheme-components/elements/Paragraph/Paragraph";

export const TelcoFaqs = ({ settings }) => {
  const items = settings.settings.items || [];
  const [activeIndex, setActiveIndex] = useState(0);

  const questionStyle = settings.settings?.section?.question_style || 'b_medium_light';
  const askedContentStyle = settings.settings?.section?.asked_content_style || 'b_tiny_light';

  const onTitleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section>
      <div className="flex flex-col w-full">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {/* Accordion Header */}
            <div 
              className={`
                flex justify-between items-center cursor-pointer p-5
                ${activeIndex === index
                  ? 'bg-[#272726] text-white rounded-tl rounded-tr'
                  : activeIndex === index + 1
                    ? 'bg-transparent'
                    : 'bg-transparent border-b border-black'
                }`
              }
              onClick={() => onTitleClick(index)}
            >
              <div className="flex flex-col flex-1 lg:py-2">
                <div className={questionStyle}>
                  {`Q: ${item.question}`}
                </div>
              </div>
              <div className={`inline-flex items-center justify-center w-10 h-11 
                transition-transform duration-300 ${
                  activeIndex === index ? 'rotate-90' : 'rotate-0'
                }`}
              >
                <svg width="44" height="40" viewBox="0 0 44 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id={`mask0_telco_faq_${index}`} style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="44" height="40">
                    <rect x="44" y="3.8147e-06" width="40" height="44" transform="rotate(90 44 3.8147e-06)" fill="#D9D9D9"/>
                  </mask>
                  <g mask={`url(#mask0_telco_faq_${index})`}>
                    <path d="M24.2 20L15.7667 12.3333L18.3333 10L29.3333 20L18.3333 30L15.7667 27.6667L24.2 20Z" fill={activeIndex === index ? "white" : "black"}/>
                  </g>
                </svg>
              </div>
            </div>
            <div
              className={`accordion-content overflow-hidden transition-all duration-300 ease-in-out ${
                activeIndex === index ? "bg-white max-h-[1000px]" : "max-h-0"
              }`}
            >
              <div className="flex flex-col gap-5 px-8 py-7 rounded-bl rounded-br">
                {item.asked_content && (
                  <div className="flex flex-col gap-1">
                    {item.asked_title && (
                      <div className={`b_medium_light`}>
                        {item.asked_title}
                      </div>
                    )}
                    {item.asked_subtitle && (
                      <div className="b_a5">
                        {item.asked_subtitle}
                      </div>
                    )}
                    <Paragraph 
                      text={item.asked_content} 
                      type={askedContentStyle} 
                      classes="pt-[10px]"
                      maxChars={0}
                    />
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default TelcoFaqs;